export default __webpack_public_path__ + "static/media/Img_Dashboard_PE.27764b23.jpg";